<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.intervencoes"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(ciap)="{item}">
                {{`${item.ciap.codigo} - ${item.ciap.descricao}`}}
            </template>

            <template v-slot:cell(actions)="{index, item}">
                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

export default {
    components: {Modal},
    data: () => ({
        fields: [
            {key: 'ciap', label: 'CIAP 2', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o CIAP?', async () => {
                this.data.model.intervencoes.splice(index, 1)
            })
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>